// extracted by mini-css-extract-plugin
module.exports = {"container":"a10a3f92e9--container--Aic8n","content":"a10a3f92e9--content--mvVQn"};